




























import {Component, Vue} from 'vue-property-decorator'
import StoresStore from "@/store/modules/StoresStore";
import MenusStore from "@/store/modules/MenusStore";
import {Util} from "@/_global/utils";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";

@Component({
    components: {}
})
export default class StoresSelector extends Vue {
    get stores() {
        return StoresStore.all;
    }

    get selectedStores() {
        return this.menu.store_ids || [];
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[this.menuId] || {}
    }

    get menuId(): number {
        return Number(this.$route.params['menuId']);
    }

    private async onClickStore(storeId: number) {
        const edited: CMS.Menu = Util.deepCopy(this.menu);
        if (this.isSelected(storeId)) {
            edited.store_ids = this.selectedStores.filter(v => v != storeId);
            await MenusStore.deleteMenuStore({storeId:storeId, menu:edited});
        } else {
            edited.store_ids = this.selectedStores.concat([storeId]);
            await MenusStore.addMenuStore({storeId:storeId, menu:edited});
        }
    }

    private isSelected(storeId: number): boolean {
        return this.selectedStores.indexOf(storeId) >= 0;
    }
}
